import getConfig from 'next/config'

import {
  BRAND_LOGO_PATHS,
  BRAND_NAMES,
  PRESIDENT_CARD_BRAND_NAME,
} from '@src/utils/brand/const'

export function isPresident() {
  const { publicRuntimeConfig } = getConfig()
  const { BRAND } = publicRuntimeConfig
  return BRAND === PRESIDENT_CARD_BRAND_NAME
}

export const brandLogoPath = isPresident()
  ? BRAND_LOGO_PATHS.PRESIDENT_CARD
  : BRAND_LOGO_PATHS.UPSIDER

export const brandLogoAlt = isPresident()
  ? BRAND_NAMES.PRESIDENT_CARD
  : BRAND_NAMES.UPSIDER

export function calculateWidthByBrand(width: number) {
  return isPresident() ? width * 1.3 : width
}

export const brandName = isPresident()
  ? BRAND_NAMES.PRESIDENT_CARD
  : BRAND_NAMES.UPSIDER

export const brandCardName = isPresident() ? brandName : 'UPSIDERカード'
